import styled from "@emotion/styled"
import { breakPoints } from "../config/theme"

export const Label = styled.p`
  font-family: "Arial";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  margin: 0;
  padding: 0;

  @media only screen and (max-width: ${breakPoints.mobile}) {
    font-size: 20px;
  }
`
